<uilab-mat-chip-listbox #chips aria-label="Style Selection" selectable>
  @for (s of styles; track s) {
    <uilab-mat-chip-option
      [selected]="s.iconstyle == selectedStyle"
      (click)="showStyle(s.iconstyle)"
      >
      {{ s.iconstyle | titlecase }}
    </uilab-mat-chip-option>
  }
</uilab-mat-chip-listbox>

<uilab-mat-form-field appearance="fill" id="category">
  <uilab-mat-label>Category</uilab-mat-label>
  <uilab-mat-select
    (selectionChange)="showCategory($event)"
    [(ngModel)]="selectedCategory"
    >
    @for (c of categories; track c) {
      <uilab-mat-option [value]="c.category">
        {{ c.category }}
      </uilab-mat-option>
    }
  </uilab-mat-select>
</uilab-mat-form-field>
